<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">充换电一张网服务平台</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          充换电一张网服务平台面向新能源汽车与电动自行车充换电基础设施的一体化管理需求，围绕“找站—充电—换电—结算”全流程，构建以数据中台为核心、综合监管系统与运营服务系统为两翼的“一擎双翼”体系。平台整合运营商、场站、充电站、换电站、桩群与电池等多源数据，打通充电与换电业务壁垒，实现资源一张图、监管一条链、服务一站式。
        </p>
        <p class="content-paragraph">
          平台面向车主提供附近站点查询、空闲桩与可用电池查询、在线预约、精准导航、扫码充电与换电预约、无感支付与错峰充电引导；面向运营企业提供订单账单、会员营销、设备运维、电池资产管理与经营分析；面向行业主管部门提供企业监管、资源负荷评估、实时监控告警、远程运维、选址优化与领导驾驶舱，支撑城市充换电资源科学规划与安全运行。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">便捷充换电</h3>
            <ul class="capability-list"><li>附近站点</li><li>空闲桩查询</li><li>在线预约</li><li>精准导航</li><li>扫码充电</li><li>换电预约</li><li>无感支付</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">综合监管</h3>
            <ul class="capability-list"><li>企业监管</li><li>资源管理</li><li>实时监控</li><li>告警处置</li><li>远程运维</li><li>安全监管</li><li>负荷评估</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">数据中枢</h3>
            <ul class="capability-list"><li>数据采集整合</li><li>错峰充电引导</li><li>选址优化</li><li>资源调度</li><li>指标分析</li><li>领导驾驶舱</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/tc-mobile.svg"
              alt="海南华德科技有限公司 充换电一张网服务平台 - 车主端 · 找站找桩与无感支付"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>车主端 · 找站找桩与无感支付
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/tc-screen.svg"
              alt="海南华德科技有限公司 充换电一张网服务平台 - 运行监测 · 充换电负荷分时热力"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>运行监测 · 充换电负荷分时热力
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/tc-regulate.svg"
              alt="海南华德科技有限公司 充换电一张网服务平台 - 综合监管 · 实时监控与告警处置"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>综合监管 · 实时监控与告警处置
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/tc-operate.svg"
              alt="海南华德科技有限公司 充换电一张网服务平台 - 运营服务 · 场站经营与订单账单"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>运营服务 · 场站经营与订单账单
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/softwareWs16.vue